import { useEffect } from 'react';

const IOS_URL = 'https://apps.apple.com/us/app/autoplace-al-makina-n%C3%AB-shitje/id6753959493';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=al.autoplace.app';
const FALLBACK_URL = 'https://autoplace.al';

export default function AppRedirect() {
  useEffect(() => {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/i.test(ua)) {
      window.location.replace(IOS_URL);
    } else if (/Android/i.test(ua)) {
      window.location.replace(ANDROID_URL);
    } else {
      window.location.replace(FALLBACK_URL);
    }
  }, []);

  return null;
}
